import axios from "axios";
import { ADMIN_TOKEN_KEY } from "./authApi";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
const EVENT_SLUG = "davangere-members-day-2026";

function headers() {
  // Fall back to the devadmin token when embedded in the DevAdmin console,
  // mirroring the admin↔devadmin fallback used by adminApi.
  const t = localStorage.getItem(ADMIN_TOKEN_KEY) || localStorage.getItem("bni-devadmin-token");
  return t ? { Authorization: `Bearer ${t}` } : {};
}

export const softLaunchApi = {
  monitor: (includeAll = false) =>
    axios.get(`${API}/admin/soft-launch/monitor`, {
      params: { event_slug: EVENT_SLUG, include_all: includeAll },
      headers: headers(),
    }).then((r) => r.data),

  resendInvoice: (regId) =>
    axios.post(`${API}/admin/registrations/${regId}/resend-invoice`, {}, { headers: headers() }).then((r) => r.data),

  resendWhatsapp: (regId) =>
    axios.post(`${API}/admin/registrations/${regId}/resend-whatsapp`, {}, { headers: headers() }).then((r) => r.data),

  reconcile: (regId) =>
    axios.post(`${API}/admin/registrations/${regId}/reconcile`, {}, { headers: headers() }).then((r) => r.data),
};
